import React, { useEffect, useState } from "react";
import ImagePrinterWorkflow from "../../images/printer-cycle.svg";
import ImageMobilePrinterWorkflow from "../../images/printer-cycle-mobile.png";
import InView from "react-intersection-observer";
import HeaderAnim from "../common/utils/animations/textRevealAnimation";
import LazyLoad from 'react-lazyload';

export default function FlexprintCsTechnology() {
  const _isMounted = false;
  const [isMobile, setisMobile] = useState(false);
  const [isVisible, setisVisible] = useState(false);

  useEffect(() => {
    const setValues = () => {
      setisMobile(window.innerWidth <= 767);
    };
    setValues();
    window.addEventListener('resize', () => {
      setValues();
    });
    return () => {
      window.removeEventListener('resize', () => {
        setValues();
      });
    };
  });
  return (
    <InView as="div" className="cs-technology-section section-gap fp-technology-section" onChange={(inView) => setisVisible(inView)} threshold={[0.2]}>
      <div className="container-small section-gap-small">
        <div className="technology-inner">
          <div className="text-center">
            <h2 className="theme-color-title purple-color">{isVisible ? <HeaderAnim header="TECHNOLOGY BACKBONE for growth" /> : ""}</h2>
            <h3 className="h3">The Internet of Printers (Things)</h3>
          </div>
          <p>The client wanted to explore opportunities to automate support and service using the printers' machine data. After a series of discussions and explorations, we found that printer devices generate millions of unstructured email logs. In addition, based on the model and make, each device generates logs in a completely different format and content. We needed to create a platform that can provide unfettered access to comprehensive and enriched log data in real-time for powering analytical apps and business insights.</p>

          <p>We built a machine data platform that can collect, curate, and enrich the machine logs and then analyze them to generate actionable insights for each machine and customer. The platform collects logs in real-time, parses them, analyzes the alerts, and generates requests for the client support teams.</p>
        </div>
      </div>
      <div className="cs-technology-image">
        <div className="container">
          {!isMobile && <>
          <LazyLoad>
            <img src={ImagePrinterWorkflow} className="cb-devops-automation" title="Machine Data Platform" alt="machine data platform" />
          </LazyLoad>
          </>}
          {isMobile && <>
          <LazyLoad>
            <img src={ImageMobilePrinterWorkflow} className="cb-devops-automation" title="Machine Data Platform" alt="machine data platform" />
          </LazyLoad>
          </>}
        </div>
      </div>
    </InView>
  );
}

